export default {
  app: {
    privacy: {
      policy: 'beartas príobháideachais',
      expansive: 'Trí Expansive a úsáid, aontaíonn tú le {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Seisiún imithe in éag',
    sessionExpiredDescription:
      'Tá do sheisiún imithe in éag. Logáil isteach arís chun leanúint ar aghaidh ag úsáid na feidhmchláir.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Roghnaigh teanga',
      chooseLanguageDescription:
        'Roghnaigh do theanga roghnaithe don fheidhmchlár. Athróidh sé seo teanga an chomhéadain agus an ábhair.',
    },
    userSelection: {
      cancel: 'Cealaigh',
      createNewUser: 'Níl a n-ainm liostaithe',
      newUser: 'Úsáideoir nua',
      selectAnExistingUser: 'Roghnaigh úsáideoir atá ann cheana',
      selectUserHint:
        'Roghnaigh úsáideoir atá ann cheana nó cruthaigh ceann nua chun leanúint ar aghaidh.',
      startTypingToSearch: 'Tosaigh ag clóscríobh...',
    },
    verification: {
      codeVerification: {
        continue: 'Lean ar aghaidh',
        header: 'Iontráil cód rochtana an tsuímh',
        invalidCode: 'Cód neamhbhailí, bain triail eile as.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Lean ar aghaidh gan suíomh a fhíorú',
        enterSiteAccessCode: 'Iontráil cód rochtana an tsuímh',
        locationNotEnabledOrAvailable: 'Cén fáth a bhfuil mé ag féachaint air seo?',
        notAvailable: {
          description: 'Níl suíomh GPS tacaíocht leis an bhfeiste seo.',
          header: 'Níl suíomh tacaíocht',
        },
        notEnabled: {
          description: 'Níl seirbhísí suíomh cumasaithe nó níor tugadh cead.',
          header: 'Níl suíomh cumasaithe',
        },
        notVerified: {
          description: 'Tugann GPS le fios nach bhfuil tú ar an suíomh.',
          header: 'Suíomh gan fhíorú',
        },
        tryAgain: 'Bain triail eile as',
        unavailable: {
          description: 'Níorbh fhéidir linn do shuíomh GPS a fhíorú.',
          header: 'Suíomh GPS ar fáil',
        },
        unknown: {
          description: 'Ní féidir linn do shuíomh a chinneadh.',
          header: 'Suíomh anaithnid',
        },
        verified: {
          description: 'Tugann GPS le fios go bhfuil tú ar an suíomh.',
          header: 'Suíomh fíoraithe',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Níl aon acmhainní le fáil',
        emptyDescription: 'Níl aon acmhainní nasctha leis an ordú oibre seo.',
        warrantyParts: 'Céim chinnteachta na gcodanna',
        serialNumber: 'Uimhir shraith',
        none: '<níl aon rud>',
      },
      updates: {
        emptyTitle: 'Níl aon nuashonruithe le fáil',
        emptyDescription: 'Níl aon nuashonruithe ar fáil don ordú oibre seo.',
        unknownUser: 'Úsáideoir anaithnid',
        none: 'Níl aon rud',
        addComment: {
          buttonLabel: 'Cuir trácht leis',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Dúshláin',
          no: 'Níl',
          yes: 'Tá',
        },
      },
    },
    attachmentsList: {
      attachments: 'Ceangaltáin',
      documents: 'Doiciméid',
      siteDocuments: 'Doiciméid an tsuímh',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Dúshláin',
        induction: 'Tús',
        safeToProceed: 'Sábháilte chun leanúint ar aghaidh',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Dáta dliteanais',
        activeSessions: 'Seisiúin gníomhacha',
        activeSessionsDescription:
          'Tá tú cheana féin seiceáilte isteach sna hoibreacha ordaithe seo a leanas. Ní mór duit seiceáladh amach as na hoibreacha ordaithe seo sula seiceálfaidh tú isteach i n-ordú oibre nua.',
        resumeSession: 'Aththosú',
        startTime: 'Tosaíodh ag',
        unexpectedErrorTitle: 'Earráid neamhthráthach',
        unexpectedErrorMessage:
          'Tharla earráid neamhthráthach agus tú ag iarraidh do sheisiúin a chruthú. Bain triail eile as níos déanaí.',
        engineerNotFound: 'Innealtóir nach bhfuil le fáil',
        engineerNotFoundDescription:
          'Níl an t-innealtóir atá á lorg agat le fáil sa chóras. Déan teagmháil lenár n-údarás chun tuilleadh cúnamh a fháil.',
      },
      verification: {
        code: {
          description:
            'Chun seiceáladh isteach, faigh an cód 4-digit ó bhainisteoir an tsuímh nó ó dhuine eile atá ceaptha.',
        },
        geo: {
          continue: 'Lean ar aghaidh',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Faigh an cód rochtana ó bhainisteoir an láithreáin nó ón gceangaltaithe ainmnithe chun do chuairt a chríochnú.',
            checkOut: 'Seiceáil amach',
            completeBeforeLeaving: 'Comhlánaigh an foirm seo sula bhfágann tú.',
            continue: 'Lean ar aghaidh',
            noResolutionSelected: 'Roghnaigh réiteach sula leanfaidh tú ar aghaidh.',
            quoteRequired: {
              hint: 'Cuairt críochnaithe, luachan le leanúint',
              label: 'Teastaíonn luachan',
            },
            returnVisitRequired: {
              hint: 'Tiocfaimid ar ais chun críochnú',
              label: 'Teastaíonn cuairt ar ais',
            },
            serviceCompleted: {
              hint: 'Níl aon gníomh eile ag teastáil',
              label: 'Seirbhís críochnaithe',
            },
            uploadCheckout: 'Uaslódáil comhad, grianghraf, nó físeán',
            visitNotes: 'Nótaí cuairte',
            workOrderResolution: 'Réiteach ordú oibre',
            enterNotes: 'Iontráil aon nótaí anseo...',
            errors: {
              timedOut: 'Am istigh, sáraíodh 30 soicind. Déan iarracht arís le do thoil.',
              closingSession: 'Earráid ag dúntadh an tseisiúin',
            },
          },
          success: {
            description:
              'Go raibh maith agat as cuairt a thabhairt ar {site}. | Tá 1 ordú oibre oscailte fágtha ag {site}. | Tá {count} ordú oibre oscailte fágtha ag {site}.',
            endVisit: 'Críochnaigh cuairt',
            header: 'Seiceáladh amach go rathúil',
            viewWorkOrders: 'Seiceáil isteach i n-ordú oibre eile',
          },
          verification: {
            code: {
              description:
                'Chun seiceáladh amach, faigh an cód 4-digit ó bhainisteoir an tsuímh nó ó dhuine eile atá ceaptha.',
              continue: 'Lean ar aghaidh',
            },
            geo: {
              checkOut: 'Seiceáil amach',
              continue: 'Lean ar aghaidh',
            },
          },
        },
        detail: {
          assets: 'Acmhainní',
          call: 'Glaoigh',
          checkOut: 'Seiceáil amach',
          closed: 'Dúnta',
          details: 'Sonraí',
          dueBy: 'Dáta dliteanais',
          manageEngineers: 'Bainistigh innealtóirí',
          notAvailable: 'Níl ar fáil',
          pointOfContact: 'Duine teagmhála',
          siteAccessTimes: 'Amanna rochtana an tsuímh',
          siteAccessInstructions: 'Treoracha rochtana',
          siteAddress: 'Seoladh an tsuímh',
          siteNotes: 'Nótaí an tsuímh',
          siteTelephone: 'Guthán an tsuímh',
          siteLocation: 'Suíomh an tsuímh',
          updates: 'Nuashonruithe',
          more: 'Tuilleadh',
          mismatchErrorTitle: 'Earráid ordú oibre',
          mismatchErrorMessage:
            'Níl an t-ordú oibre atá á lorg agat comhoiriúnach leis an ordú atá tú seiceáilte isteach ann. Seiceáil do ordú oibre agus bain triail eile as.',
          siteDocuments: 'Doiciméid an tsuímh',
          validFrom: 'Valid ó',
          validUntil: 'Valid go dtí',
          documentName: 'Ainm doiciméid',
          documentType: 'Cineál doiciméid',
          attachments: 'Comhoiriúnachtaí ordú oibre',
          download: 'Íoslódáil',
          workDetails: 'Sonraí oibre',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Cuir innealtóir cúnta leis',
            assistantEngineers: 'Innealtóirí cúnta',
            description:
              'Ar chúiseanna slándála, le do thoil sonnaigh ainmneacha gach innealtóra atá ar an suíomh.',
            editMainEngineer: 'Eagar innealtóir príomha',
            errors: {
              creatingEngineer: 'Earráid ag cruthú innealtóra',
              creatingSession: 'Earráid ag cruthú seisiúin',
            },
            header: 'Innealtóirí ar an suíomh',
            mainEngineer: 'Innealtóir príomha',
            newAssistantEngineer: 'Iontráil a n-ainm iomlán',
            next: 'Ar aghaidh',
            removeEngineer: 'Bain innealtóir',
            selectExistingAssistantEngineer: 'Tosaigh ag clóscríobh a n-ainm',
          },
          index: {
            description:
              'Ar chúiseanna slándála, le do thoil sonnaigh ainmneacha gach innealtóra atá ar an suíomh.',
            errorCreatingEngineer: 'Earráid ag cruthú innealtóra, bain triail eile as le do thoil.',
            header: 'Innealtóirí ar an suíomh',
            hintMainEngineer: 'Iontráil ainm iomlán an innealtóra príomha',
            newMainEngineer: 'Innealtóir príomha nua',
            next: 'Ar aghaidh',
            selectExistingMainEngineer: 'Roghnaigh innealtóir príomha atá ann cheana',
            yes: 'Tá',
            no: 'Níl',
            mainEngineerLabel: 'An tú an príomh-innealtóir?',
          },
        },
        index: {
          callUsOn: 'Glaoigh orainn ar {phoneNumber}',
          description: 'Ní féidir leat an rud atá uait a fháil?',
          dueBy: 'Dáta dliteanais',
          header: 'Roghnaigh ordú oibre',
          notAvailable: 'Níl ar fáil',
          searchWorkOrders: 'Cuardaigh ordú oibre...',
        },
        manageEngineers: {
          manageEngineers: 'Bainistigh innealtóirí',
          notWorking: 'Oibrithe neamhghníomhacha',
          pause: 'Goipeáil',
          resume: 'Aththosú',
          workingNow: 'Oibrithe gníomhacha',
          startTime: 'Am tosaithe',
          endTime: 'Am críochnaithe',
          duration: 'Tréimhse',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Aiseolas',
            feedbackDescription:
              'Le do thoil, tabhair aiseolas ar an ordú oibre chun cabhrú linn ár seirbhísí a fheabhsú.',
            feedbackLabel: 'Aiseolas',
            filesLabel: 'Ceangaltáin',
            submissionLabel: 'Seol aiseolas',
          },
          hazards: {
            back: 'Glaoigh ar ais',
            hazards: 'Dúshláin',
            next: 'Ar aghaidh',
            no: 'Níl',
            noTasksForHazard: 'Níl aon tascanna le comhlánú don dúshlán seo.',
            yes: 'Tá',
          },
          induction: {
            continue: 'Lean ar aghaidh',
            induction: 'Tús',
          },
          index: {
            checkIn: 'Seiceáil isteach',
            description: 'Le do thoil, comhlánaigh an measúnú riosca seo don obair roghnaithe.',
            fail: 'Theip ar phróiseáil na seiceálaí ordú oibre tosaithe.',
            haltMessage:
              'Dúshláin fhéideartha faighte. Le do thoil, stad an obair, athbhreithnigh na treoirlínte sábháilteachta, agus déan teagmháil le do mhaoirseoir le haghaidh treoracha breise.',
            header: 'Seiceálacha tosaithe oibre',
            endVisit: 'Críochnaigh cuairt',
            leaveFeedback: 'Fág aiseolas',
          },
          safeToProceed: {
            continue: 'Lean ar aghaidh',
            safeToProceed: 'Sábháilte chun leanúint ar aghaidh',
          },
        },
      },
    },
    index: {
      title: 'Fáilte',
      description: 'Scan an cód QR ag do suíomh chun tús a chur leis.',
    },
    login: {
      errorTitle: 'Earráid neamhthráthach',
      errorMessage: 'Tharla earráid neamhthráthach. Bain triail eile as an cód QR a scanadh.',
    },
    unauthenticated: {
      welcome: {
        title: 'Fáilte chuig {site}',
        description:
          'Sula féidir linn aon ordú oibre a thaispeáint duit, ní mór dúinn do chuid sonraí a fhíorú. Cliceáil ar an gcnaipe thíos chun leanúint ar aghaidh.',
        next: 'Lean ar aghaidh',
      },
      index: {
        errorTitle: 'Earráid neamhthráthach',
        errorMessage: 'Tharla earráid neamhthráthach. Bain triail eile as an cód QR a scanadh.',
      },
      contractor: {
        title: 'Cé leis a bhfuil tú ag obair?',
        contractor: 'Conradhóir',
        contractorLabel: 'Tosaigh ag clóscríobh ainm do chomhlachta',
        contractorHint: 'Ní mór duit 3 charachtar nó níos mó a iontráil chun torthaí a fheiceáil',
        defaultSelectPlaceholder: '--Le do thoil roghnaigh--',
        next: 'Ar aghaidh',
      },
      user: {
        title: 'Cé tú?',
        cancel: 'Cealaigh',
        createNewUserLabel: 'Níl mo ainm liostaithe',
        existingUserLabel: 'Tosaigh ag clóscríobh do ainm',
        existingUserHint: 'Ní mór duit 3 charachtar nó níos mó a iontráil chun torthaí a fheiceáil',
        newUserLabel: 'Iontráil do ainm iomlán',
        next: 'Ar aghaidh',
        user: 'Úsáideoir',
      },
      verification: {
        methods: {
          add: {
            add: 'Cuir modh fíoraithe leis',
            defaultSelectPlaceholder: '--Le do thoil roghnaigh--',
            emailLabel: 'Ríomhphost',
            existingMethodWarning:
              'Tá iarratas comhoiriúnachta agat cheana féin ar an modh fíoraithe seo atá ag fanacht le ceadú ó riarachán. Má chuireann tú nua, déanfaidh sé seo é a chur in ionad.',
            method: 'Modh',
            methodLabel: 'Modh',
            mobileCountryHint: 'Le do thoil roghnaigh do chód tíre',
            mobileCountryLabel: 'Cód tíre gutháin móibíle',
            mobileHint: 'Le do thoil, iontráil do número gutháin móibíle',
            mobileLabel: 'Guthán móibíle',
            title: 'Cuir modh fíoraithe leis',
          },
          confirm: {
            confirm: 'Confirm',
            description: 'Le do thoil, dearbhaigh do mhodh fíoraithe chun leanúint ar aghaidh.',
            label: 'Iontráil do chód',
            resend: 'Seol ar ais',
            resendPrompt: 'Ní bhfuair tú cód?',
            title: 'Déanfaidh Modh Fíoraithe a Dhearbhú',
          },
          confirmed: {
            description:
              'Fógrófar duit nuair a bheidh an modh fíoraithe seo ceadaithe ag do riarachán, agus ansin is féidir leat é a úsáid chun do shíntiús a fhíorú.',
            forceApproval:
              'Go dtí go mbeidh sé ceadaithe, ní féidir leat rochtain a fháil ar na hoibreacha ordaithe.',
            nonForceApproval:
              'Idir an dá linn, is féidir leat leanúint ar aghaidh ag rochtain ar na hoibreacha ordaithe le rochtain laghdaithe.',
            nonForceApprovalButtonLabel: 'Lean ar aghaidh le rochtain laghdaithe',
            title: 'Ag fanacht le ceadú',
          },
          addNew: 'Cuir modh fíoraithe nua leis',
          description:
            'Ní mór dúinn do shíntiús a fhíorú chun rochtain iomlán a thabhairt duit ar an ordú oibre.',
          email: 'Ríomhphost',
          hint: 'Seolfar nasc chuig do mhodh fíoraithe roghnaithe a thugann rochtain iomlán duit ar an ordú oibre. Má tá gá agat le haon mhodh fíoraithe atá ann cheana a athrú, déan teagmháil lenár riarachán.',
          label: 'Roghnaigh modh fíoraithe',
          next: 'Ar aghaidh',
          pendingHint: 'Ag fanacht le ceadú ó do riarachán',
          sms: 'SMS',
          title: 'Fíorú',
        },
        optional: {
          hint: 'Tabharfaidh fíorú do chuid sonraí úsáideora rochtain iomlán duit ar an ordú oibre',
          label: 'An muốn tú do chuid sonraí úsáideora a fhíorú?',
          next: 'Ar aghaidh',
          no: 'Níl',
          noHint:
            'Ní theastaíonn uaim mo chuid sonraí úsáideora a fhíorú agus leanúint ar aghaidh le rochtain laghdaithe ar an ordú oibre',
          title: 'Fíorú',
          yes: 'Tá',
          yesHint:
            'Teastaíonn uaim mo chuid sonraí úsáideora a fhíorú agus rochtain iomlán a fháil ar an ordú oibre',
        },
        sent: {
          description:
            'Seoladh nasc logála isteach chuig {identifier}. Le do thoil, cliceáil ar an nasc chun do logáil a chríochnú.',
          title: 'Nasc logála isteach sent',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Inné',
      today: 'Inniu',
      days: {
        monday: 'Dé Luain',
        tuesday: 'Dé Máirt',
        wednesday: 'Dé Céadaoin',
        thursday: 'Déardaoin',
        friday: 'Dé hAoine',
        saturday: 'Dé Sathairn',
        sunday: 'Dé Domhnaigh',
      },
      months: {
        january: 'Eanáir',
        february: 'Feabhra',
        march: 'Márta',
        april: 'Aibreán',
        may: 'Bealtaine',
        june: 'Meitheamh',
        july: 'Iúil',
        august: 'Lúnasa',
        september: 'Meán Fómhair',
        october: 'Deireadh Fómhair',
        november: 'Samhain',
        december: 'Nollaig',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Tharla rud éigin mícheart',
      message: 'Le do thoil, bain triail as an cód QR a scanadh arís.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Úsáideoir anaithnid',
      },
      none: 'Níl aon rud',
      types: {
        stateTransition: 'Athrú stádais',
        contractorAssigned: 'Conradhóir ceaptha',
        engineerAssigned: 'Innealtóir ceaptha',
        serviceAssigned: 'Seirbhís ceaptha',
        priorityChanged: 'Athrú tosaíochta',
        actionableDateChanged: 'Athrú dáta gníomhaíochta',
        dueDateChanged: 'Athrú dáta tuairiscithe',
        etaDateChanged: 'Athrú dáta ETA',
        spendLimitApproved: 'Ceadúnas teorann caitheamh',
        spendLimitCancelled: 'Cealadh iarratais teorann caitheamh',
        spendLimitRejected: 'Diúltaíodh teorann caitheamh',
        spendLimitRequested: 'Iarratas ar theorann caitheamh',
        jobSheetUploaded: 'Duillín oibre uaslódáilte',
        slaAlertSent: 'Aláram SLA ama le freagairt',
        issuedWorkPermit: 'Ceadúnas oibre eisithe',
        requestForServiceSent: 'Iarratas ar sheirbhís sent',
        comment: 'Trácht curtha leis',
        unknown: 'Eachtra anaithnid',
      },
      labels: {
        actionableDate: 'Dáta gníomhaíochta',
        comment: 'Trácht',
        file: 'Comhad',
        contractor: 'Conradhóir',
        dueDate: 'Dáta tuairiscithe',
        etaDate: 'Dáta ETA',
        engineer: 'Innealtóir',
        priority: 'Tosaíocht',
        requestForService: 'Iarratas ar sheirbhís',
        service: 'Seirbhís',
        spendLimit: 'Teorann caitheamh',
        status: 'Stádas',
        workPermit: 'Ceadúnas oibre',
      },
    },
  },
}
